'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEYS = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  ENTER: 'Enter',
  BACKSPACE: 'Backspace',
  ESCAPE: 'Escape',
  COMMA: ',',
  TAB: 'Tab',
  META: 'Meta',
  CONTROL: 'Control',
  A: 'a',
  C: 'c'
};

exports.default = KEYS;